"use strict"

angular.module("core")
.service("InvoiceService", function(
    $resource, FlashBag, appConfig, gettextCatalog, common, ReadOnlyPermissionService
) {
    var resource = $resource(appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        create: {
            method: "POST"
        },
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: ReadOnlyPermissionService.responseErrorInterceptor}
        }
    });

    var pdfResource = $resource(appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/pdf/:id/:pdfFormat/:outputType/", {id: "@id", pdfFormat: "@pdfFormat", outputType: "@outputType"}, {
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    var ownerResource = $resource(appConfig.API_SERVER + "/invoice/customer/resend/:invoice_uuid/", {invoice_uuid: "@invoice_uuid"}, {
        update: {
            method: "PUT",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.create = function(data) {
        return (new resource(data)).$create();
    };

    this.query = function(params) {
        return resource.query(params);
    };

    this.get = function(id) {
        var params = {
            id: id
        };
        return resource.get(params);
    };

    this.delete = function(id) {
        return resource.delete({id: id}).$promise;
    };

    this.downloadPDF = function(id, pdfFormat) {
        return pdfResource.save(
            {
                id: id,
                pdfFormat: pdfFormat,
                outputType: "print"
            }
        )
    }

    this.emailPDF = function(id, pdfFormat, recipient) {
        return pdfResource.save(
            {
                id: id,
                email: recipient,
                pdfFormat: pdfFormat,
                outputType: "email"
            }
        )
    }

    this.getOtherChargesLocalized = function() {
        var resource = $resource(appConfig.API_SERVER + "/charges/other-charge-translations/", {}, {
            get: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return resource.get();
    };

    this.getTaxesLocalized = function() {
        var resource = $resource(appConfig.API_SERVER + "/charges/tax-translations/", {}, {
            get: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return resource.get();
    };

    this.getCustomerAvailableVendors = function() {
        var resource = $resource(appConfig.API_SERVER + "/invoice/customer/available-vendors/", {}, {
            query: {
                method: "GET",
                isArray: true,
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return resource.query();
    };

    this.inviteOwner = function(instance) {
        return instance.$update();
    };

    this.getOwner = function(invoice_uuid) {
        return ownerResource.get(
            {"invoice_uuid": invoice_uuid}
        );
    };

    this.getAvailableSortFields = function() {
        return {
            customer_name: {
                name: gettextCatalog.getString("Name"),
                normal: gettextCatalog.getString("A to Z"),
                reverse: gettextCatalog.getString("Z to A")
            },
            buyer_number: {
                name: gettextCatalog.getString("Customer #"),
                normal: gettextCatalog.getString("0 to 9"),
                reverse: gettextCatalog.getString("9 to 0")
            },
            invoice_date: {
                name: gettextCatalog.getString("Invoice Date"),
                normal: gettextCatalog.getString("Past to Future"),
                reverse: gettextCatalog.getString("Future to Past")
            },
            status_date: {
                name: gettextCatalog.getString("Status Date"),
                normal: gettextCatalog.getString("Past to Future"),
                reverse: gettextCatalog.getString("Future to Past")
            },
            payment_due_date: {
                name: gettextCatalog.getString("Payment Due Date"),
                normal: gettextCatalog.getString("Past to Future"),
                reverse: gettextCatalog.getString("Future to Past")
            },
            total_amount: {
                name: gettextCatalog.getString("Total Amount"),
                normal: gettextCatalog.getString("0 to 9"),
                reverse: gettextCatalog.getString("9 to 0")
            }
        };
    }

    this.getSortFields = function() {
        return common.getSortFieldsByKeys(
            "customer_name, buyer_number, invoice_date, status_date, payment_due_date, total_amount",
            this.getAvailableSortFields()
        );
    };

    this.getStatusFilterValues = function() {
        return {
            transmitted: gettextCatalog.getString("Transmitted"),
            partially_paid: gettextCatalog.getString("Partially paid"),
            paid: gettextCatalog.getString("Paid"),
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice/invoice.service.js
// module id = 429
// module chunks = 0